import {h, Fragment} from "preact"
import {
    useAppState,
    useSelectedFiltersCount,
    useSort,
    useSizeOptions,
  } from "@nosto/preact";
  import { sortOptions, sizes, defaultConfig } from "../config";
  import SidebarAside from "./SidebarAside";
  import Icon from "./elements/Icon";
  import Select from "./elements/Select";
  import SelectedFilters from "./SelectedFilters";
  
  function ToggleMobileSidebarButton({ selectedFiltersCount, className }) {
    const id = "toggle-mobile-sidebar";
  
    return (
      <>
        <input
          type="checkbox"
          id={id}
          class="ns-facet-sidebar-toggle ns-d-none"
        />
        <label
          for={id}
          className={`ns-filterMobile ns-filter-mob-cat ns-act-btn-light ns-filters ns-d-md-none ns-text-align-center ns-align-items-center ${className}`}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <mask
              id="mask0_4561_11788"
              style="mask-type:alpha"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="16"
              height="16"
            >
              <rect y="9.15527e-05" width="16" height="16" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_4561_11788)">
              <path
                d="M7.03785 11.3334V10.6667H8.94801V11.3334H7.03785ZM4.53785 8.33341V7.66675H11.448V8.33341H4.53785ZM2.66602 5.33341V4.66675H13.3327V5.33341H2.66602Z"
                fill="white"
              />
            </g>
          </svg>
          <span class="ns-refine-cat">Filters</span>
        </label>
      </>
    );
  }
  
  export default function CategoryToolbar({ mobile }) {
    const { from, to, size, total, handleSizeChange, sizeOptions } =
      useSizeOptions(sizes, defaultConfig.serpSize);
    const { loading, query, response, pageType } = useAppState();
    const { activeSort, setSort } = useSort(sortOptions);
    const selectedFiltersCount = useSelectedFiltersCount();
  
    const handleSortChange = (event) => {
      setSort(event.target.value);
    };
  
    const docCount = response.products?.total ?? 0;
  
    const options = sortOptions.map((o) => ({
      value: o.id,
      label: o.value.name,
    }));
  
    return (
      <div
        class={
          mobile
            ? "ns-mobile-header-controls ns-d-flex ns-flex-row ns-flex-wrap align-center ns-justify-content-between ns-align-items-end ns-d-md-none"
            : "ns-header-controls ns-d-none ns-flex-row align-center ns-justify-content-between ns-align-items-end ns-d-md-flex"
        }
        style={loading ? "opacity: 0.3; justify-content: end !important;" : ""}
      >
        {!mobile && (
          <div class="ns-total-count">
            {`${from == 0 ? "1" : from}`} - {total < to ? total : to} of {total}{" "}
            products
          </div>
        )}
        <div
          class={
            mobile
              ? "ns-d-flex ns-flex-wrap ns-d-md-block ns-w-100 ns-justify-content-between ns-sort-category-container"
              : "ns-sort-container ns-sort-category-container"
          }
        >
          {mobile && (
            <>
              <div class="mobile-toolbar-wrapper">
                <ToggleMobileSidebarButton
                  selectedFiltersCount={selectedFiltersCount}
                />
              </div>
              <div class="ns-total-count">
                {`${from == 0 ? "1" : from}`} - {total < to ? total : to} of{" "}
                {total} products
              </div>
              <Select
                value={activeSort}
                onChange={(e) => handleSortChange(e)}
                className="ns-selection-dropdown-sort-menu"
                options={options}
              />
              <SidebarAside mobile label={"toggle-mobile-sidebar"} />
            </>
          )}
          {!mobile && (
            <>
              <Select
                value={activeSort}
                onChange={(e) => handleSortChange(e)}
                className="ns-selection-dropdown-sort-menu"
                options={options}
              />
            </>
          )}
        </div>
      </div>
    );
  }
  